import { ListingColDefs } from './listing-col-defs';

export const AGGREGATED_STATUSES_FIELD = '__ui_aggregatedStatuses';

export class LicenseColDefs extends ListingColDefs {
  constructor(params) {
    super(params);
    this.licenseStatusMapping = params?.licenseStatusMapping;
  }

  licenseStatusMapping = null;

  // determines field name for license column defined in listing-col-defs
  licenseColumnFieldName = 'license';

  licenseStatusColumn = this.setColumn({
    __deckard_resize_on_scroll: true,
    headerName: 'Status',
    field: AGGREGATED_STATUSES_FIELD,
    colId: AGGREGATED_STATUSES_FIELD,
    cellRenderer: 'licenseStatusCellRenderer',
    cellRendererParams: {
      getStatusDisplayName: (status) => this.licenseStatusMapping[status],
    },
    filterParams: {
      cellRenderer: 'licenseStatusCellRenderer',
      suppressMiniFilter: true, // hides textbox in filter popover
      valueFormatter: ({ value }) => this.licenseStatusMapping[value] || value,
    },
    valueFormatter: ({ value: statuses }) => statuses?.[0],
  });
}
